import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';

import closeIcon from '../../../assets/icons/closeIcon.svg';

export const Tooltip = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box
      sx={{
        maxWidth: 400,
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
      className={'width-75'}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1rem 1rem 0 1rem'
        }}
      >
        <Button
          onClick={onClose}
          sx={{ padding: 0, marginLeft: 'auto', minWidth: 0 }}
        >
          <img src={closeIcon} alt="Close" />
        </Button>
        <Box sx={{ paddingBottom: '1rem' }}>
          <Typography
            align="left"
            sx={{
              fontFamily: 'Calibri',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '20px',
              color: '#002A3A',
              marginTop: '10px'
            }}
          >
            <b>GLIM</b> = Global Leadership Initiative on Malnutrition
          </Typography>
          <Typography
            align="left"
            sx={{
              fontFamily: 'CalibriItalic',
              fontSize: '1rem',
              fontWeight: 700,
              lineHeight: '1.25rem',
              color: '#004F71',
              padding: '0.9375rem 0'
            }}
          >
            Reference:
          </Typography>
          <Typography
            align="left"
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: 400,
              lineHeight: '1.25rem',
              color: '#004F71'
            }}
          >
            Cederholm, T
            <span style={{ fontFamily: 'CalibriItalic' }}> et al.</span> Clin
            Nutr. 2019 Feb;38(1):1-9.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
